"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterMemberList = void 0;
const moment_1 = __importDefault(require("moment"));
const getDaysToFilter = (filters) => {
    const days = [];
    filters.forEach((filter) => {
        if (isDayKey(filter.key) && filter.value) {
            const value = parseInt(filter.value.toString());
            !isNaN(value) && days.push(value);
        }
    });
    return days;
};
const filterByDays = (member, days) => (filter) => {
    var _a;
    if (!isDayKey(filter.key) || !filter.value)
        return false;
    return Boolean(member.subscription === "premium" ||
        member.subscription === "vip" ||
        ((_a = member.coachingDays) === null || _a === void 0 ? void 0 : _a.some((day) => days.includes(day))));
};
const filterByBoolean = (member) => (filter) => {
    if (!filter.value === true)
        return false;
    if (member[filter.key] !== undefined) {
        return !!member[filter.key];
    }
    else if (member.events[filter.key] !== undefined) {
        return !!member.events[filter.key];
    }
    return false;
};
const isDayKey = (key) => {
    return key.search(/day\[[0-9]]/) !== -1;
};
const hasDayKey = (filter) => {
    return filter.key.search(/day\[[0-9]]/) !== -1;
};
const isBooleanFilterAndHasValue = (filter) => {
    return filter.value === true;
};
const isSubscriptionTypeAndHasValue = (filter) => {
    return filter.key === "subscription" && !!filter.value;
};
const filterMemberByBirthday = (member) => {
    return member.events.daysToBirthday >= 0 && member.events.daysToBirthday < 8;
};
var StrictBooleanFilterKey;
(function (StrictBooleanFilterKey) {
    StrictBooleanFilterKey["hasBirthday"] = "hasBirthday";
    StrictBooleanFilterKey["isIntakeUndone"] = "isIntakeUndone";
    StrictBooleanFilterKey["daysToSubscriptionsEnd"] = "daysToSubscriptionsEnd";
})(StrictBooleanFilterKey || (StrictBooleanFilterKey = {}));
const memberInFilter = (member, filters, timeFormat = "YYYY-MM-DD") => {
    let result = true;
    const days = getDaysToFilter(filters);
    const dayFilters = filters.filter(hasDayKey);
    filters.forEach((filter) => {
        var _a;
        if (!result ||
            !filter.value ||
            ["newOld", "oldNew"].includes(filter.value.toString()))
            return;
        //DAYS
        if (isDayKey(filter.key)) {
            result = dayFilters.some(filterByDays(member, days));
            return;
        }
        //BOOLEAN KEYS
        if (filter.value === true) {
            if (filter.key === StrictBooleanFilterKey.daysToSubscriptionsEnd) {
                result = member.events[filter.key] <= 14;
                return;
            }
            else if (filter.key === StrictBooleanFilterKey.hasBirthday) {
                result = filterMemberByBirthday(member);
                return;
            }
            else if (member[filter.key] !== undefined) {
                result = member[filter.key] ? result : false;
                return;
            }
            else if (member.events[filter.key] !== undefined) {
                result = member.events[filter.key] ? result : false;
                return;
            }
        }
        // DATES
        if (filter.key == "subscriptionStart") {
            result = moment_1.default
                .utc(member.subscriptionStartDate, timeFormat)
                .isSameOrAfter(moment_1.default.utc(filter.label.toString(), timeFormat));
            return;
        }
        if (filter.key == "subscriptionEnd") {
            result = moment_1.default
                .utc(member.subscriptionStartDate, timeFormat)
                .isSameOrBefore(moment_1.default.utc(filter.label.toString(), timeFormat));
            return;
        }
        // DATES - period
        if (filter.key == "periodStart") {
            result = moment_1.default
                .utc(member.periodStartDate, timeFormat)
                .isSameOrAfter(moment_1.default.utc(filter.label.toString(), timeFormat));
            return;
        }
        if (filter.key == "periodEnd") {
            result = moment_1.default
                .utc(member.periodStartDate, timeFormat)
                .isSameOrBefore(moment_1.default.utc(filter.label.toString(), timeFormat));
            return;
        }
        //TEXT VALUES
        if (isSubscriptionTypeAndHasValue(filter)) {
            if (((_a = member[filter.key]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !==
                filter.value.toLowerCase()) {
                result = false;
                return result;
            }
        }
        return;
    });
    return result;
};
exports.default = memberInFilter;
const looseFiltersKeys = [
    "isNewStarter",
    "isProlonger",
    "isRejoiner",
    "hasNewCoach"
];
const isLooseFilter = (looseFiltersKey) => (filter) => looseFiltersKey.includes(filter.key);
const isStrictFilter = (looseFiltersKey) => (filter) => !looseFiltersKey.includes(filter.key);
const filterByLoosFilters = (booleanFilters) => (member) => {
    if (!member.id || !booleanFilters.length)
        return true;
    return booleanFilters.some(filterByBoolean(member));
};
const hasFilterValue = (filter) => !!filter.value;
const findMemberByName = (name) => (member) => member.name === name;
const sortMemberList = (filter, timeFormat) => (a, b) => {
    const da = (0, moment_1.default)(a["lastActiveRaw"], timeFormat);
    const db = (0, moment_1.default)(b["lastActiveRaw"], timeFormat);
    const daa = filter.value === "newOld" ? da : db;
    const dbb = filter.value === "newOld" ? db : da;
    if (daa.isBefore(dbb))
        return 1;
    else
        return -1;
};
const filterMemberList = (members, filters, search, timeFormat) => {
    const strictFilters = filters.filter(isStrictFilter(looseFiltersKeys));
    const looseFilters = filters.filter(isLooseFilter(looseFiltersKeys));
    const booleanFilters = looseFilters.filter(isBooleanFilterAndHasValue);
    const filteredByLooseFilters = members.filter(filterByLoosFilters(booleanFilters));
    const hasStrictFiltersValues = strictFilters.some(hasFilterValue);
    const list = members.map((member) => {
        const m = { ...member };
        if (!search && !hasStrictFiltersValues && !booleanFilters.length) {
            return m;
        }
        if ((search &&
            member.name.toLowerCase().search(search.toLowerCase()) === -1) ||
            !memberInFilter(m, strictFilters, timeFormat)) {
            m.id = "";
        }
        if (!hasStrictFiltersValues && looseFilters.length && !search) {
            m.id = "";
        }
        if (booleanFilters.length &&
            filteredByLooseFilters.find(findMemberByName(m.name))) {
            m.id = member.id;
        }
        return m;
    });
    filters.forEach((filter) => {
        var _a;
        if (["newOld", "oldNew"].includes((_a = filter.value) === null || _a === void 0 ? void 0 : _a.toString())) {
            list.sort(sortMemberList(filter, timeFormat));
        }
    });
    return list;
};
exports.filterMemberList = filterMemberList;
//# sourceMappingURL=memberInFilter.js.map